var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"div"},[_c('b-breadcrumb',_vm._l((_vm.links),function(link,index){return _c('b-breadcrumb-item',{key:index,class:index === _vm.links.length - 1 ? 'seleccionado' : '',attrs:{"to":index === _vm.links.length - 1
            ? null
            : { name: link.routeName, params: link.routeParams }}},[_vm._v(" "+_vm._s(link.name)+" ")])}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }